/**
 * Print / image styles for 55mm thermal bill (รูปแบบบิล).
 * Width fixed at 55mm, height follows content.
 */

/** ความกว้างใบบิล thermal (mm) — ใช้ทั้งพิมพ์และดาวน์โหลดรูป */
export const RECEIPT_THERMAL_WIDTH_MM = 55;

/** จัดรูปแบบจำนวนเงินแบบบิล (คั่นหลักพันด้วยจุด) เช่น 50.000.000 */
export function formatBillAmount(amount: number): string {
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export const RECEIPT_PRINT_STYLES_48MM = `
  @media print {
    @page { size: ${RECEIPT_THERMAL_WIDTH_MM}mm auto; margin: 0; }
    body {
      margin: 0;
      padding: 0;
      width: ${RECEIPT_THERMAL_WIDTH_MM}mm !important;
      min-height: auto;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      font-weight: 600;
      color: #000;
    }
  }
  * { box-sizing: border-box; }
  body {
    font-family: 'Courier New', Courier, monospace;
    width: ${RECEIPT_THERMAL_WIDTH_MM}mm;
    max-width: ${RECEIPT_THERMAL_WIDTH_MM}mm;
    margin: 0 auto;
    padding: 3mm 3mm;
    background: #fff;
    color: #0a0a0a;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .bill-header {
    text-align: center;
    padding-bottom: 2mm;
    margin-bottom: 2mm;
  }
  .bill-logo {
    width: 32px;
    height: 32px;
    margin: 0 auto 1.5mm;
    display: block;
    object-fit: contain;
  }
  .bill-brand {
    font-size: 14px;
    font-weight: 800;
    color: #000;
    margin: 0 0 0.5mm;
    letter-spacing: 0.02em;
  }
  .bill-address {
    font-size: 9px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0;
  }
  .bill-sep {
    border: none;
    border-bottom: 1px dashed #333;
    margin: 2mm 0;
    padding: 0;
  }
  .bill-line {
    font-size: 10px;
    font-weight: 600;
    margin: 0.5mm 0;
    text-align: left;
  }
  .bill-line-label { font-weight: 600; color: #1a1a1a; }
  .bill-items { margin: 1mm 0; }
  .bill-item-line {
    font-size: 10px;
    font-weight: 600;
    margin: 0.5mm 0;
    text-align: left;
  }
  .bill-discount {
    margin: 2mm 0;
    font-size: 10px;
    font-weight: 600;
    text-align: left;
  }
  .bill-discount-line { margin: 0.5mm 0; font-weight: 600; }
  .bill-discount-line.discount-amount { font-weight: 700; color: #0d4f26; }
  .bill-total-section {
    text-align: center;
    margin-top: 2.5mm;
    padding-top: 2.5mm;
  }
  .bill-total-label {
    font-size: 10px;
    font-weight: 700;
    color: #000;
    margin: 0 0 1mm;
  }
  .bill-total-amount {
    font-size: 16px;
    font-weight: 800;
    color: #000;
    margin: 0;
  }
  .bill-footer {
    text-align: center;
    margin-top: 3mm;
    padding-top: 2.5mm;
    font-size: 9px;
    font-weight: 600;
    color: #1a1a1a;
  }
  .bill-footer-tagline { margin: 0 0 0.5mm; font-weight: 700; }
  .bill-footer-thanks { margin: 0; font-weight: 600; }
  .bill-meta-nos {
    font-size: 8px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0.5mm 0 0;
    line-height: 1.35;
    word-break: break-word;
  }
  .bill-badge {
    display: inline-block;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 0.04em;
    margin: 0 0 1mm;
    padding: 0.4mm 1.2mm;
    border: 1px solid #000;
  }
  .bill-group-date {
    font-size: 10px;
    font-weight: 800;
    margin: 2.5mm 0 1mm;
    padding-bottom: 0.5mm;
    border-bottom: 1px solid #222;
  }
  .bill-item-block {
    margin: 0 0 1.8mm;
    padding-bottom: 1.2mm;
    border-bottom: 1px dotted #666;
  }
  .bill-item-block:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .bill-item-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 2mm;
    margin: 0 0 0.4mm;
  }
  .bill-item-title {
    font-size: 10px;
    font-weight: 800;
    flex: 1;
    min-width: 0;
  }
  .bill-item-no {
    font-size: 9px;
    font-weight: 700;
    color: #333;
    flex-shrink: 0;
  }
  .bill-item-sub {
    font-size: 9px;
    font-weight: 600;
    color: #222;
    margin: 0.2mm 0;
  }
  .bill-item-amt {
    font-size: 11px;
    font-weight: 800;
    text-align: right;
    margin-top: 0.6mm;
  }
  .bill-count-line {
    font-size: 9px;
    font-weight: 700;
    margin: 0.5mm 0;
  }
  .bill-profile {
    text-align: center;
    margin: 2mm 0;
    padding: 2mm 0;
  }
  .bill-profile-label {
    font-size: 9px;
    font-weight: 600;
    margin: 0 0 1mm;
    color: #1a1a1a;
  }
  .bill-profile-qr { display: block; margin: 1mm auto; width: 24mm; height: 24mm; object-fit: contain; }
  .bill-profile-url {
    font-size: 8px;
    font-weight: 600;
    word-break: break-all;
    color: #1a1a1a;
    margin: 0;
  }
`;

/** alias — ความกว้างจริงคือ 55mm */
export const RECEIPT_PRINT_STYLES_55MM = RECEIPT_PRINT_STYLES_48MM;

/**
 * สร้าง HTML ส่วนลิงก์ + QR ไปหน้า profile สาธารณะ (สำหรับพิมพ์ในใบเสร็จ)
 */
export function buildReceiptProfileSection(
  memberId: string,
  profileUrl: string,
  qrDataUrl: string,
): string {
  return `
    <div class="bill-profile">
      <div class="bill-profile-label">ເບິ່ງ profile ຂໍ້ມູນສະມາຊິກ</div>
      <img src="${qrDataUrl}" alt="QR" class="bill-profile-qr" />
      <div class="bill-profile-url">${profileUrl}</div>
    </div>
  `;
}

/** Logo inline style for bill header (32px) */
export const RECEIPT_LOGO_STYLE_48MM =
  "width:32px;height:32px;margin:0 auto 1.5mm;display:block;object-fit:contain;";

export const RECEIPT_LOGO_STYLE_55MM = RECEIPT_LOGO_STYLE_48MM;

/** ຊື່ຄູຊ່ວຍສອນ (unique, ບໍ່ຊ້ຳ) */
export function uniqueAssistInstructorNames(
  names: string[] | null | undefined,
): string[] {
  return [...new Set((names ?? []).map((n) => n.trim()).filter(Boolean))];
}

/** ແຖວຂໍ້ຄວາມຄູຊ່ວຍສຳລັບໃບເກັບເງິນ — null ຖ້າບໍ່ມີ */
export function formatAssistInstructorBillLine(
  names: string[] | null | undefined,
): string | null {
  const unique = uniqueAssistInstructorNames(names);
  if (unique.length === 0) return null;
  return `ຄູຊ່ວຍ: ${unique.join(", ")}`;
}

/** HTML ແຖວຄູຊ່ວຍສຳລັບ thermal bill */
export function formatAssistInstructorBillHtml(
  names: string[] | null | undefined,
): string {
  const line = formatAssistInstructorBillLine(names);
  if (!line) return "";
  return `<div class="bill-item-line">${line}</div>`;
}
